import { css as l } from "styled-components";
import { r as c } from "../../palettes-Bw24w7AF.js";
import "../Theme/themes.es.js";
import { getSpacings as d, getPaletteColors as r, getPaletteBase as e, getPaletteBorder as t, getPaletteBackground as a, getPaletteText as $ } from "../Theme/utils.es.js";
import "react";
import "../../jsx-runtime-C5mzlN2N.js";
import "../../CssBaseline-Bp4jdUgb.js";
const p = {
  xs: l`
    padding: 7px ${d("lg")};
    gap: ${d("xs")};
  `,
  sm: l`
    padding: ${d("md")} ${d("lg")};
    gap: ${d("xs")};
  `,
  md: l`
    padding: 10px 14px;
    gap: ${d("xs")};
  `,
  lg: l`
    padding: 10px ${d("xl")};
    gap: ${d("sm")};
  `,
  xl: l`
    padding: ${d("lg")} 18px;
    gap: ${d("sm")};
  `,
  "2xl": l`
    padding: ${d("xl")} 22px;
    gap: 10px;
  `
}, u = {
  xs: l`
    height: 16px;
    width: 16px;
  `,
  sm: l`
    height: 20px;
    width: 20px;
  `,
  md: l`
    height: 20px;
    width: 20px;
  `,
  lg: l`
    height: 20px;
    width: 20px;
  `,
  xl: l`
    height: 20px;
    width: 20px;
  `,
  "2xl": l`
    height: 24px;
    width: 24px;
  `
}, m = {
  contained: l`
    color: ${$("primary.brand")};
    border: 1px solid ${(o) => r(o.$color)(o)[600]};
    background-color: ${(o) => r(o.$color)(o)[600]};

    &:hover, &:active {
      border: 1px solid ${(o) => r(o.$color)(o)[700]};
      background-color: ${(o) => r(o.$color)(o)[700]};
    }

    &:focus {
      box-shadow: 0px 0px 0px 4px ${(o) => c(r(o.$color)(o)[400], 0.24)};
    }

    &:disabled {
      border-color: ${t("disabled.subtle")};
      background-color: ${a("disabled.default")};
    }
  `,
  outlined: l`
    color: ${(o) => r(o.$color)(o)[700]};
    background-color: ${e("white")};
    border: 1px solid ${(o) => r(o.$color)(o)[300]};
    
    &:hover, &:active {
      background-color: ${(o) => r(o.$color)(o)[50]};
    }

    &:focus {
      box-shadow: 0px 0px 0px 4px ${(o) => c(r(o.$color)(o)[400], 0.24)};
    }

    &:disabled {
      border-color: ${t("disabled.subtle")};
      background-color: ${a("disabled.default")};
    }
  `,
  text: l`
    border: none;
    padding: 0;

    color: ${(o) => r(o.$color)(o)[700]};
    background-color: ${e("transparent")};

    &:hover, &:active {
      color: ${(o) => r(o.$color)(o)[800]};
    }

    &:focus {
      color: ${(o) => r(o.$color)(o)[800]};
    }
    
  `,
  ghost: l`
    border: none;
    
    color: ${(o) => r(o.$color)(o)[700]};
    background-color: ${e("transparent")};

    &:hover, &:active {
      color: ${(o) => r(o.$color)(o)[800]};
      background-color: ${(o) => r(o.$color)(o)[50]};
    }

    &:focus {
      background-color: ${(o) => r(o.$color)(o)[25]};
      box-shadow: 0px 0px 0px 4px ${(o) => c(r(o.$color)(o)[400], 0.24)};
    }
    
    &:disabled {
      background-color: ${e("transparent")};
    }
  `
};
export {
  u as iconSizeStyles,
  p as sizeStyles,
  m as variantStyles
};
